/**
 *
 * LifeInsuredForm
 *
 */

 import React, { useEffect } from 'react';
 import { connect } from 'react-redux';
 import { change } from 'redux-form';
 import {
   Grid,
   Typography,
   Collapse,
   Button,
   Card,
   FormControlLabel,
   Radio,
   Divider,
 } from '@material-ui/core';
 import PropTypes from 'prop-types';
 import styled from 'styled-components';
 import {
   Field,
   FieldArray,
   reduxForm,
   FormSection,
   formValueSelector,
 } from 'redux-form/immutable';
 import { InjectedFormProps, WrappedFieldArrayProps } from 'redux-form';
 import { useTheme, makeStyles } from '@material-ui/core/styles';
 import validate from './validate';
 import { fromJS } from 'immutable';
 import { FormattedMessage, useIntl } from 'react-intl';
 import messages from '../../messages';
 import globalMessages from 'containers/App/messages';
 import FormTextField from 'components/FormTextField';
 import OptSwitch from 'components/OptSwitch';
 import FormSelect from 'components/FormSelect';
 import PersonalDetails from 'components/PersonalDetails';
 import FormRadioGroup from 'components/FormRadioGroup';
 import CustomRadio from 'components/CustomRadioButton';
 import { getStartDate, getCoverages } from '../../helper';
 import { dimension } from 'styles/constants';
 import { SetCoveragesListAction } from '../../actions';
 import { changePlaceHolderColor, changeToTitleCase } from 'helpers/lang';
 import LoadingDialog from 'components/LoadingDialog';
 
 const useStyle = makeStyles(theme => ({
   hr: {
     marginTop: theme.spacing(2),
     marginBottom: theme.spacing(3),
     marginLeft: '-2rem',
     marginRight: '-2rem',
     borderTop: '1px solid rgba(0, 0, 0, 0.12)',
   },
   radioForm: {
     display: 'flex',
     alignItems: 'center',
     direction: 'column',
   },
 }));
 
 const Wrapper = styled(({ theme, ...props }) => <Grid {...props} />)`
   && {
     display: flex;
     flex-direction: column;
     width: 100%;
   }
 `;
 
 const CardWrapper = styled(({ theme, ...props }) => <Card {...props} />)`
   && {
     padding: ${props => props.theme.spacing(2)}px;
     margin-bottom: 10px;
     max-width: 640px;
   }
 `;
 
 const renderSwitch = ({
   input: { onChange, value },
   theme,
   disabled,
   nameType,
   isPolicyOwnerIndividual,
   isInsuredOnePolicyOwner,
   isInsuredTwo,
   isInsuredTwoPolicyOwner,
 }) => {
   if (
     (isPolicyOwnerIndividual &&
       isInsuredOnePolicyOwner &&
       isInsuredTwo &&
       isInsuredTwoPolicyOwner) ||
     !isPolicyOwnerIndividual
   ) {
     if (nameType === 'isPolicyOwnerIndividual' && value) {
       value = false;
     }
   }
   return (
     <OptSwitch
       checked={value}
       value={value}
       color="default"
       onChange={onChange}
       labelNegative={<FormattedMessage {...messages.no} />}
       disabled={disabled}
     />
   );
 };
 
 renderSwitch.propTypes = {
   theme: PropTypes.object,
   disabled: PropTypes.bool,
 };
 
 const lessThan = otherField => (value, previousValue, _) => {
   if (!value) return '';
   return value.length <= otherField ? value : previousValue;
 };
 
 const RenderIndividual = ({
   fields,
   options,
   insuredOne,
   disabled,
   isInsuredTwoPolicyOwner,
   policyOwnerIndividual,
 }) => {
   const theme = useTheme();
   const intl = useIntl();
   return (
     <div>
       {fields.map((individual, index) => (
         <Grid container key={individual}>
           <Grid container spacing={3}>
             <Grid item>
               <Field
                 name={`${individual}.firstName`}
                 disabled={disabled}
                 style={{ width: 260 }}
                 component={FormTextField}
                 label={<FormattedMessage {...globalMessages.firstName} />}
                 type="text"
                 color="primary"
                 margin="normal"
                 normalize={lessThan(45)}
                 variant="standard"
                 placeholder={intl.formatMessage(
                   globalMessages.fieldPlaceholder,
                 )}
                 format = {(value) => changeToTitleCase(value)} 
               />
             </Grid>
             <Grid item>
               <Field
                 name={`${individual}.lastName`}
                 disabled={disabled}
                 style={{ width: 260 }}
                 component={FormTextField}
                 label={<FormattedMessage {...globalMessages.familyName} />}
                 color="primary"
                 margin="normal"
                 normalize={lessThan(40)}
                 variant="standard"
                 placeholder={intl.formatMessage(
                   globalMessages.fieldPlaceholder,
                 )}
                 format = {(value) => changeToTitleCase(value)} 
               />
             </Grid>
             <Grid item>
               <Field
                 name={`${individual}.prospectId`}
                 disabled={disabled}
                 type="hidden"
                 component={FormTextField}
                 color="primary"
                 margin="normal"
                 variant="standard"
                 style={{ visibility: 'hidden' }}
               />
             </Grid>
             <Grid item>
               <Field
                 name={`${individual}.relationshipToLifeInsured`}
                 disabled={disabled}
                 style={{
                   width: 355,
                   color: changePlaceHolderColor(
                     policyOwnerIndividual[index]?.relationshipToLifeInsured,
                   ),
                 }}
                 component={FormSelect}
                 options={[
                   { value: 'Select an option', title: 'Select an option' },
                   ...options.applicationRelationship,
                 ]}
                 label={
                   <FormattedMessage {...messages.relationWithLifeInsured} />
                 }
                 type="text"
                 color="primary"
                 margin="normal"
                 variant="standard"
               />
             </Grid>
 
             <Grid item>
               <Grid container alignItems="center" justify="center">
                 {fields.length !== 2 &&
                 !insuredOne.isPolicyOwner &&
                 !isInsuredTwoPolicyOwner ? (
                   <Button
                     variant="text"
                     margin="normal"
                     disabled={disabled}
                     style={{
                       marginTop: dimension.spacing.m,
                       color: theme.palette.primary.dark,
                     }}
                     onClick={() =>
                       fields.push(
                         fromJS({
                           firstName: '',
                           lastName: '',
                           relationshipToLifeInsured: 'Select an option',
                           isPolicyOwner: true,
                           isLifeInsured: false,
                           isPrimaryLifeInsured: false,
                         }),
                       )
                     }
                   >
                     <FormattedMessage {...messages.addAnotherPolicyOwner} />
                   </Button>
                 ) : null}
               </Grid>
             </Grid>
           </Grid>
         </Grid>
       ))}
     </div>
   );
 };
 
 RenderIndividual.propTypes = {
   ...WrappedFieldArrayProps,
   options: PropTypes.object,
   insuredOne: PropTypes.object,
   insuredTwo: PropTypes.object,
 };
 
 function LifeInsuredForm({
   disabled,
   options,
   insuredOne,
   insuredTwo,
   isInsuredTwo,
   lifeBasis,
   futuraConfig,
   isPolicyOwnerIndividual,
   isInsuredOnePolicyOwner,
   isInsuredTwoPolicyOwner,
   handleSubmit,
   onSubmit,
   resetInsuredPolicyOwner,
   policyOwnerIndividual,
   resetPolicyOwnerIndividual,
   resetCoverages,
   change,
   isBoldInsuredPolicyOwner,
   location,
 }) {
   const theme = useTheme();
   const classes = useStyle();
 
   if (isPolicyOwnerIndividual) {
     //resetInsuredPolicyOwner();
   }
   useEffect(() => {
     if (isBoldInsuredPolicyOwner) change('isPolicyOwnerIndividual', false);
   }, [isBoldInsuredPolicyOwner]);
 
   useEffect(() => {
     if (policyOwnerIndividual.length === 2) {
       change('insuredTwo.isPolicyOwner', false);
     }
   }, [policyOwnerIndividual.length]);
 
   const minDob = getStartDate()
     .toDate()
     .setFullYear(
       getStartDate()
         .toDate()
         .getFullYear() - 75,
     );
   const maxDob = getStartDate()
     .toDate()
     .setFullYear(
       getStartDate()
         .toDate()
         .getFullYear() - 18,
     );
   return (
     <>
       {location.state.type === 1 ? (
         <LoadingDialog isLoading />
       ) : (
         <form onSubmit={() => handleSubmit(onSubmit)}>
           <Wrapper theme={theme}>
             <FormSection name="insuredOne">
               <PersonalDetails
                 options={options}
                 disabled={disabled}
                 formValues={insuredOne}
                 minDate={minDob}
                 maxDate={maxDob}
                 disabledPolicyOwner={
                   (isPolicyOwnerIndividual && isInsuredTwoPolicyOwner) ||
                   (isPolicyOwnerIndividual &&
                     policyOwnerIndividual.length === 2)
                 }
                 isNationalityShowing={false}
               />
             </FormSection>
 
             <CardWrapper variant="outlined" theme={theme}>
               <Grid
                 container
                 direction="row"
                 alignItems="center"
                 justify="space-between"
               >
                 <Typography variant="body1">
                   <FormattedMessage {...messages.isSecondInsured} />
                 </Typography>
 
                 <Field
                   name="isInsuredTwo"
                   component={renderSwitch}
                   disabled={disabled}
                   theme={theme}
                   margin="normal"
                   nameType="isInsuredTwo"
                   isPolicyOwnerIndividual={isPolicyOwnerIndividual}
                   isInsuredOnePolicyOwner={isInsuredOnePolicyOwner}
                   isInsuredTwo={isInsuredTwo}
                   isInsuredTwoPolicyOwner={isInsuredTwoPolicyOwner}
                 />
               </Grid>
               <Collapse in={isInsuredTwo}>
                 <hr className={classes.hr} />
                 <FormSection name="insuredTwo">
                   <PersonalDetails
                     disabled={disabled}
                     options={options}
                     formValues={insuredTwo}
                     minDate={minDob}
                     maxDate={maxDob}
                     disabledPolicyOwner={
                       (isPolicyOwnerIndividual && isInsuredOnePolicyOwner) ||
                       (isPolicyOwnerIndividual &&
                         policyOwnerIndividual.length === 2)
                     }
                     isNationalityShowing={false}
                   />
                 </FormSection>
 
                 <Divider />
 
                 <Field
                   name="lifeBasis"
                   type="radio"
                   disabled={disabled}
                   style={{ marginTop: theme.spacing(2) }}
                   component={FormRadioGroup}
                   onChange={() =>
                     resetCoverages(getCoverages(futuraConfig.features))
                   }
                 >
                   <Typography
                     variant="body1"
                     style={{ margin: theme.spacing(1) }}
                   >
                     <FormattedMessage {...messages.whatPolicyBasisRequired} />
                   </Typography>
 
                   <Grid container direction="column">
                     <FormControlLabel
                       disabled={disabled}
                       control={<CustomRadio checked={lifeBasis === 'JLFD'} />}
                       value="JLFD"
                       style={{ margin: theme.spacing(1) }}
                       label={<FormattedMessage {...messages.jlfd} />}
                       labelPlacement="end"
                     />
 
                     <FormControlLabel
                       disabled={disabled}
                       control={<CustomRadio checked={lifeBasis === 'JLLS'} />}
                       value="JLLS"
                       style={{ margin: theme.spacing(1) }}
                       label={<FormattedMessage {...messages.jlld} />}
                       labelPlacement="end"
                     />
 
                     <FormControlLabel
                       disabled={disabled}
                       control={<CustomRadio checked={lifeBasis === 'JLBD'} />}
                       value="JLBD"
                       style={{ margin: theme.spacing(1) }}
                       label={<FormattedMessage {...messages.jlbd} />}
                       labelPlacement="end"
                     />
                   </Grid>
                 </Field>
               </Collapse>
             </CardWrapper>
 
             <CardWrapper variant="outlined" theme={theme}>
               <Grid
                 container
                 direction="row"
                 alignItems="center"
                 justify="space-between"
               >
                 <Typography variant="body1">
                   <FormattedMessage {...messages.isPolicyOwnerIndividual} />
                 </Typography>
                 <Field
                   name="isPolicyOwnerIndividual"
                   component={renderSwitch}
                   theme={theme}
                   margin="normal"
                   nameType="isPolicyOwnerIndividual"
                   onChange={newVal => {
                     if (!newVal.target.value) resetPolicyOwnerIndividual();
                   }}
                   disabled={
                     (isInsuredOnePolicyOwner &&
                       isInsuredTwo &&
                       isInsuredTwoPolicyOwner) ||
                     disabled
                   }
                   isPolicyOwnerIndividual={isPolicyOwnerIndividual}
                   isInsuredOnePolicyOwner={isInsuredOnePolicyOwner}
                   isInsuredTwo={isInsuredTwo}
                   isInsuredTwoPolicyOwner={isInsuredTwoPolicyOwner}
                 />
               </Grid>
               {isPolicyOwnerIndividual && <hr className={classes.hr} />}
               <Collapse in={isPolicyOwnerIndividual}>
                 <FieldArray
                   name="policyOwnerIndividual"
                   component={RenderIndividual}
                   disabled={disabled}
                   insuredOne={insuredOne}
                   insuredTwo={insuredTwo}
                   options={options}
                   policyOwnerIndividual={policyOwnerIndividual}
                   isInsuredTwoPolicyOwner={isInsuredTwoPolicyOwner}
                 />
               </Collapse>
             </CardWrapper>
           </Wrapper>
         </form>
       )}
     </>
   );
 }
 
 LifeInsuredForm.propTypes = {
   ...InjectedFormProps,
   options: PropTypes.object,
   futuraConfig: PropTypes.object,
   insuredOne: PropTypes.object,
   insuredTwo: PropTypes.object,
   isInsuredTwo: PropTypes.bool,
   lifeBasis: PropTypes.string,
   isInsuredOnePolicyOwner: PropTypes.bool,
   isInsuredTwoPolicyOwner: PropTypes.bool,
   isPolicyOwnerIndividual: PropTypes.bool,
   resetInsuredPolicyOwner: PropTypes.func,
   resetCoverages: PropTypes.func,
   policyOwnerIndividual: PropTypes.array,
   resetPolicyOwnerIndividual: PropTypes.func,
 };
 
 const withForm = reduxForm({
   validate,
   form: 'lifeAssuredForm',
   enableReinitialize: true,
   keepDirtyOnReinitialize: true,
 })(LifeInsuredForm);
 
 const selector = formValueSelector('lifeAssuredForm');
 const mapStateToProps = state => {
   let isInsuredTwo = selector(state, 'isInsuredTwo');
   let lifeBasis = selector(state, 'lifeBasis');
   let insuredOne = selector(state, 'insuredOne');
   let insuredTwo = selector(state, 'insuredTwo');
   let isInsuredOnePolicyOwner = false;
   let isInsuredTwoPolicyOwner = false;
   if (insuredOne) {
     var insuredData = insuredOne.toJS();
     isInsuredOnePolicyOwner = insuredData.isPolicyOwner;
   }
   if (insuredTwo) {
     var insuredData = insuredTwo.toJS();
     isInsuredTwoPolicyOwner = insuredData.isPolicyOwner;
   }
   if (!isInsuredTwo) isInsuredTwoPolicyOwner = false;
   let policyOwnerIndividual = selector(state, 'policyOwnerIndividual');
   let isPolicyOwnerIndividual = selector(state, 'isPolicyOwnerIndividual');
   let isBoldInsuredPolicyOwner =
     isInsuredOnePolicyOwner && isInsuredTwoPolicyOwner;
   return {
     isInsuredTwo,
     lifeBasis,
     insuredTwo: insuredTwo?.toJS() || {},
     insuredOne: insuredOne?.toJS() || {},
     isPolicyOwnerIndividual,
     isInsuredOnePolicyOwner,
     isInsuredTwoPolicyOwner,
     policyOwnerIndividual: policyOwnerIndividual?.toJS() || [],
     isBoldInsuredPolicyOwner,
   };
 };
 
 const mapDispatchToProps = dispatch => ({
   resetInsuredPolicyOwner: () =>
     dispatch(change('lifeAssuredForm', 'insuredTwo.isPolicyOwner', false)),
   resetCoverages: val => dispatch(SetCoveragesListAction(val)),
 
   resetPolicyOwnerIndividual: () =>
     dispatch(
       change(
         'lifeAssuredForm',
         'policyOwnerIndividual',
         fromJS([
           {
             prospectId: '',
             firstName: '',
             lastName: '',
             relationshipToLifeInsured: 'Select an option',
             isPolicyOwner: true,
             isLifeInsured: false,
             isPrimaryLifeInsured: false,
           },
         ]),
       ),
     ),
 });
 
 const withConnect = connect(mapStateToProps, mapDispatchToProps)(withForm);
 
 export default withConnect;
 